module.exports = __webpack_public_path__ + "img/britishvirginislands.9dfe24eb.svg";